import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useContext } from 'react';
import { useMediaQuery } from '@mui/material';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS } from '@contentful/rich-text-types';
import { useTheme } from '@mui/material/styles';
import TAGTypography from '../elements/TAGTypography/TAGTypography';
import FocalPointImage from './FocalPointImage';
import { FacilityContext } from '../../contexts/FacilityContext';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Box, Grid } from '@mui/material';
import { RichText } from '.';
export var CheckedIcon = function CheckedIcon() {
  return React.createElement(Box, {
    sx: {
      height: '24px',
      width: '24px',
      display: 'inline-block'
    }
  }, React.createElement(FocalPointImage, {
    image: {
      description: 'checked icon',
      file: {
        contentType: 'string',
        url: 'https://www.aspendental.com/-/media/aspendentaldotcom/check-icon.svg'
      }
    }
  }));
};
export var XmarkIcon = function XmarkIcon() {
  return React.createElement(Box, {
    sx: {
      height: '24px',
      width: '24px',
      display: 'inline-block',
      '& img': {
        height: '24px',
        width: '24px'
      }
    }
  }, React.createElement(FocalPointImage, {
    image: {
      description: 'xmark icon',
      file: {
        contentType: 'string',
        url: 'https://www.aspendental.com/-/media/aspendentaldotcom/cross-icon.svg'
      }
    }
  }));
};

var ADTable = function ADTable(_ref) {
  var _renderNode, _renderNode2, _renderNode3;

  var _ref$border = _ref.border,
      border = _ref$border === void 0 ? true : _ref$border,
      branding = _ref.branding,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 'bodySmallBook' : _ref$fontSize,
      footnote = _ref.footnote,
      tableContent = _ref.tableContent,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;

  var _useContext = useContext(FacilityContext),
      facilityState = _useContext.state;

  var mobileWidth = useMediaQuery('(max-width:420px)');
  var theme = useTheme(); // Template specific functions

  var pseudoCode = [':highlighted:', ':checked:', ':xmark:'];

  var isHighlighted = function isHighlighted(elems) {
    if (elems.find(function (e) {
      return e.value.includes(':highlighted:');
    })) {
      return true;
    }

    return false;
  };

  var isChecked = function isChecked(elems) {
    if (elems.find(function (e) {
      return e.value.includes(':checked:');
    })) {
      return true;
    }

    return false;
  };

  var isXmarked = function isXmarked(elems) {
    if (elems.find(function (e) {
      return e.value.includes(':xmark:');
    })) {
      return true;
    }

    return false;
  };

  var getCompareTableHeader = function getCompareTableHeader(elems) {
    var _imgElem$data, _imgElem$data$target;

    var titleElem = elems.find(function (e) {
      return e.value.includes('image*title');
    });
    var title = titleElem.value.replace(':image*title*', '');
    var imgElem = elems.find(function (e) {
      return e.nodeType == 'embedded-entry-inline';
    });
    var img = imgElem === null || imgElem === void 0 ? void 0 : (_imgElem$data = imgElem.data) === null || _imgElem$data === void 0 ? void 0 : (_imgElem$data$target = _imgElem$data.target) === null || _imgElem$data$target === void 0 ? void 0 : _imgElem$data$target.image;
    return {
      title: title,
      img: img
    };
  };

  var removePseudo = function removePseudo(str) {
    var text = str;

    var _iterator = _createForOfIteratorHelper(pseudoCode),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var code = _step.value;
        text = text.replace(code, '');
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return text;
  }; // Data for mobile resolutions for 'default' and 'card' table variant start


  var parsed = JSON.parse(tableContent.raw);

  var edited = _objectSpread(_objectSpread({}, parsed), {}, {
    content: parsed.content.map(function (el) {
      if (el.nodeType === 'table') {
        var trt = el.content.map(function (row) {
          return row.content.map(function (_el, i) {
            return _objectSpread(_objectSpread({}, row), {}, {
              content: [row.content[i]]
            });
          });
        });
        var m = trt.map(function (_tr, tr_index) {
          return trt[0].map(function (_t, _i) {
            return [_t, trt[tr_index][_i]];
          });
        });
        var bbb = m.slice(-el.content.length + 1).flat(2);
        return _objectSpread(_objectSpread({}, el), {}, {
          content: bbb
        });
      }

      return el;
    })
  });

  var mobileDataRaw = JSON.stringify(edited);

  var mobileContent = _objectSpread(_objectSpread({}, tableContent), {}, {
    raw: mobileDataRaw
  }); // Data for mobile resolutions for 'default' and 'card' table variant end


  var getTableVariant = function getTableVariant(variant) {
    switch (variant) {
      case 'card':
        return cardTableOptions;

      case 'compare':
        return compareTableOptions;

      default:
        return defaultTableOptions;
    }
  };

  var borderStyle = "1px solid";
  var defaultTableOptions = {
    renderNode: (_renderNode = {}, _defineProperty(_renderNode, BLOCKS.TABLE, function (_, children) {
      return React.createElement(Table, {
        sx: {
          border: border && !mobileWidth ? borderStyle : 'none',
          borderColor: 'neutrals.disabled',
          borderCollapse: mobileWidth ? 'separate' : 'collapse',
          borderSpacing: mobileWidth ? '0 8px' : 'none'
        },
        "aria-label": "simple table"
      }, children);
    }), _defineProperty(_renderNode, BLOCKS.TABLE_ROW, function (_, children) {
      return React.createElement(TableRow, {
        sx: {
          border: border ? borderStyle : 'none',
          borderColor: 'neutrals.disabled',
          borderCollapse: 'collapse'
        }
      }, children);
    }), _defineProperty(_renderNode, BLOCKS.TABLE_CELL, function (_) {
      var _$content$, _$content$2, _$content$3, _$content$4;

      var fieldValue = (_$content$ = _.content[0]) === null || _$content$ === void 0 ? void 0 : _$content$.content[0].value;
      fieldValue = removePseudo(fieldValue);
      var highlighted = isHighlighted((_$content$2 = _.content[0]) === null || _$content$2 === void 0 ? void 0 : _$content$2.content);
      var checked = isChecked((_$content$3 = _.content[0]) === null || _$content$3 === void 0 ? void 0 : _$content$3.content);
      var xmarked = isXmarked((_$content$4 = _.content[0]) === null || _$content$4 === void 0 ? void 0 : _$content$4.content);
      return React.createElement(TableCell, {
        align: "center",
        sx: {
          color: 'text.primary',
          backgroundColor: highlighted ? theme.palette.backgrounds.light : '',
          border: border ? borderStyle : 'none',
          borderColor: 'neutrals.disabled',
          borderCollapse: 'collapse'
        }
      }, React.createElement(TAGTypography, {
        variant: fontSize,
        color: "text.primary"
      }, fieldValue), checked ? React.createElement(CheckedIcon, null) : xmarked ? React.createElement(XmarkIcon, null) : null);
    }), _defineProperty(_renderNode, BLOCKS.TABLE_HEADER_CELL, function (_) {
      var _$content$5, _$content$6;

      var fieldValue = (_$content$5 = _.content[0]) === null || _$content$5 === void 0 ? void 0 : _$content$5.content[0].value;
      fieldValue = removePseudo(fieldValue);
      var highlighted = isHighlighted((_$content$6 = _.content[0]) === null || _$content$6 === void 0 ? void 0 : _$content$6.content);
      return React.createElement(TableCell, {
        align: "center",
        sx: {
          fontWeight: 'bold',
          backgroundColor: highlighted ? theme.palette.backgrounds.dark : theme.palette.backgrounds.neutral,
          border: border ? borderStyle : 'none',
          borderColor: 'neutrals.disabled',
          borderCollapse: 'collapse'
        }
      }, React.createElement(TAGTypography, {
        variant: "h4",
        color: highlighted ? 'text.light' : 'text.primary',
        sx: {
          margin: '22px 0'
        }
      }, fieldValue));
    }), _renderNode)
  };
  var compareTableOptions = {
    renderNode: (_renderNode2 = {}, _defineProperty(_renderNode2, BLOCKS.PARAGRAPH, function (_, children) {
      var _$content$7;

      var p = _ === null || _ === void 0 ? void 0 : (_$content$7 = _.content[0]) === null || _$content$7 === void 0 ? void 0 : _$content$7.value;
      var para = p.includes('row*title');
      return React.createElement("p", {
        style: {
          display: para ? 'none' : 'block',
          margin: '16px 0 0 0'
        }
      }, React.createElement(TAGTypography, {
        variant: "bodyLargeBook",
        color: "text.secondary"
      }, children));
    }), _defineProperty(_renderNode2, BLOCKS.TABLE, function (_, children) {
      return React.createElement(Table, null, children);
    }), _defineProperty(_renderNode2, BLOCKS.TABLE_ROW, function (_, children) {
      var _$content$8, _$content$8$content$, _$content$8$content$$;

      var rt = (_$content$8 = _.content[0]) === null || _$content$8 === void 0 ? void 0 : (_$content$8$content$ = _$content$8.content[0]) === null || _$content$8$content$ === void 0 ? void 0 : (_$content$8$content$$ = _$content$8$content$.content[0]) === null || _$content$8$content$$ === void 0 ? void 0 : _$content$8$content$$.value;
      var rowTitle;
      var titleRegular;
      var titleBold;

      if (rt.includes('row*title')) {
        var t = rt.split('*');
        rowTitle = rt.split('*')[t.length - 1];
        var indexOfOpeningP = rowTitle.indexOf('(');
        var indexOfClosingP = rowTitle.indexOf(')');
        titleRegular = rowTitle.substring(indexOfOpeningP, indexOfClosingP + 1);
        titleBold = rowTitle.replace(titleRegular, '');
      }

      return React.createElement(Grid, {
        container: true,
        spacing: 2,
        wrap: "nowrap",
        sx: {
          justifyContent: 'space-between',
          position: 'relative'
        }
      }, rowTitle && React.createElement(Box, {
        sx: {
          position: 'absolute',
          top: '-16px',
          left: '16px',
          paddingTop: '30px',
          borderBottom: '1px solid rgb(167, 173, 176)',
          width: '100%'
        }
      }, React.createElement(TAGTypography, {
        variant: "bodyLargeBold",
        color: "text.primary"
      }, titleBold), titleRegular && React.createElement(TAGTypography, {
        variant: "bodyLargeBook",
        color: "text.primary"
      }, titleRegular)), children);
    }), _defineProperty(_renderNode2, BLOCKS.TABLE_CELL, function (_, children) {
      var _$content$9, _$content$9$content$, _$content$10, _$content$10$content$, _$content$11, _$content$11$content$, _$content$12, _$content$12$content$;

      if (_.content[0].content.find(function (el) {
        return el.nodeType == 'embedded-entry-inline';
      })) {
        var ar = _.content[0].content.filter(function (el) {
          return el.nodeType == 'embedded-entry-inline';
        });

        return React.createElement(Grid, {
          item: true,
          sm: 4,
          md: 4,
          sx: {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '30px',
            paddingTop: '48px !important',
            width: mobileWidth ? '241px' : '100%'
          }
        }, ar.map(function (elem) {
          var _facilityState$servic, _facilityState$servic2;

          var price = facilityState === null || facilityState === void 0 ? void 0 : (_facilityState$servic = facilityState.services) === null || _facilityState$servic === void 0 ? void 0 : (_facilityState$servic2 = _facilityState$servic.find(function (el) {
            return el.procedureCode == elem.data.target.procedureCode;
          })) === null || _facilityState$servic2 === void 0 ? void 0 : _facilityState$servic2.ucfPrice;
          return React.createElement(React.Fragment, null, React.createElement(TAGTypography, {
            variant: "bodySmallBook",
            color: "text.primary"
          }, elem.data.target.title), React.createElement(TAGTypography, {
            variant: "bodySmallBook",
            color: "text.primary"
          }, "From $", price));
        }));
      }

      var mark = (_ === null || _ === void 0 ? void 0 : (_$content$9 = _.content[0]) === null || _$content$9 === void 0 ? void 0 : (_$content$9$content$ = _$content$9.content[0]) === null || _$content$9$content$ === void 0 ? void 0 : _$content$9$content$.value) == ':xmark:' || (_ === null || _ === void 0 ? void 0 : (_$content$10 = _.content[1]) === null || _$content$10 === void 0 ? void 0 : (_$content$10$content$ = _$content$10.content[0]) === null || _$content$10$content$ === void 0 ? void 0 : _$content$10$content$.value) == ':xmark:' ? ':xmark:' : (_ === null || _ === void 0 ? void 0 : (_$content$11 = _.content[0]) === null || _$content$11 === void 0 ? void 0 : (_$content$11$content$ = _$content$11.content[0]) === null || _$content$11$content$ === void 0 ? void 0 : _$content$11$content$.value) == ':checked:' || (_ === null || _ === void 0 ? void 0 : (_$content$12 = _.content[1]) === null || _$content$12 === void 0 ? void 0 : (_$content$12$content$ = _$content$12.content[0]) === null || _$content$12$content$ === void 0 ? void 0 : _$content$12$content$.value) == ':checked:' ? ':checked:' : null;
      return React.createElement(Grid, {
        item: true,
        sm: 4,
        md: 4,
        sx: {
          display: 'flex',
          flexDirection: 'column',
          marginBottom: '30px',
          paddingTop: '48px !important',
          width: mobileWidth ? '241px' : '100%'
        }
      }, mark == ':checked:' ? React.createElement(CheckedIcon, null) : mark == ':xmark:' ? React.createElement(XmarkIcon, null) : children);
    }), _defineProperty(_renderNode2, BLOCKS.TABLE_HEADER_CELL, function (_) {
      var _getCompareTableHeade = getCompareTableHeader(_.content[0].content),
          img = _getCompareTableHeade.img,
          title = _getCompareTableHeade.title;

      return React.createElement(Grid, {
        item: true,
        sm: 4,
        md: 4,
        sx: {
          display: 'flex',
          paddingLeft: '8px !important'
        }
      }, React.createElement(Box, {
        sx: {
          border: 'none',
          padding: '9px 12px!important',
          background: theme.palette.backgrounds.neutral,
          boxShadow: 'none',
          marginBottom: '26px',
          width: '100%'
        }
      }, React.createElement(TAGTypography, {
        variant: "bodySmallBook",
        color: "text.primary"
      }, title), React.createElement(Box, {
        sx: {
          margin: '0 0 8px',
          display: 'flex',
          justifyContent: 'center'
        }
      }, React.createElement(Box, {
        sx: {
          borderRadius: '50%',
          backgroundColor: theme.palette.backgrounds.white,
          display: 'flex',
          justifyContent: 'center',
          padding: '5px 7px',
          width: '195px',
          height: '195px'
        }
      }, img && React.createElement(FocalPointImage, {
        image: img
      })))));
    }), _renderNode2)
  };
  var cardTableOptions = {
    renderNode: (_renderNode3 = {}, _defineProperty(_renderNode3, BLOCKS.TABLE, function (_, children) {
      return React.createElement(Table, {
        "aria-label": "simple table"
      }, children);
    }), _defineProperty(_renderNode3, BLOCKS.TABLE_ROW, function (_, children) {
      return React.createElement(Grid, {
        container: true,
        wrap: "nowrap",
        spacing: 2
      }, children);
    }), _defineProperty(_renderNode3, BLOCKS.TABLE_CELL, function (_) {
      var fieldValue = _.content[0].content[0].value;
      fieldValue = removePseudo(fieldValue);
      return React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 4,
        md: 4,
        sx: {
          display: 'flex',
          margin: '0 0 8px 0'
        }
      }, React.createElement(Box, {
        sx: {
          p: 2,
          background: theme.palette.backgrounds.neutral,
          display: 'flex',
          flex: 1
        }
      }, React.createElement(Box, {
        sx: {
          backgroundColor: 'text.light',
          flex: 1,
          padding: '8px 0',
          '& p': {
            margin: 0
          }
        }
      }, React.createElement(TAGTypography, {
        variant: "h3",
        color: "text.primary",
        sx: {
          justifyContent: 'center',
          textAlign: 'center'
        }
      }, fieldValue))));
    }), _defineProperty(_renderNode3, BLOCKS.TABLE_HEADER_CELL, function (_, children) {
      return React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 4,
        md: 4,
        sx: {
          display: 'flex'
        }
      }, React.createElement(Box, {
        sx: {
          p: 2,
          background: theme.palette.backgrounds.neutral,
          flex: 1,
          width: '100%'
        }
      }, React.createElement(TAGTypography, {
        variant: "bodySmallSemiBold",
        color: "text.primary",
        sx: {
          marginBottom: {
            xs: '16px',
            sm: '12px'
          },
          justifyContent: 'center',
          textAlign: 'center'
        }
      }, children)));
    }), _renderNode3)
  };
  return React.createElement(Box, null, React.createElement(TableContainer, null, renderRichText(mobileWidth && variant != 'compare' ? mobileContent : tableContent, getTableVariant(variant))), footnote && React.createElement(Box, {
    sx: {
      '& .MuiContainer-root': {
        maxWidth: '100%',
        margin: 0,
        padding: 0
      }
    }
  }, React.createElement(RichText, {
    branding: branding,
    content: footnote
  })));
};

export default ADTable;